import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { InviteUserGroupApi } from '../../../store/features/inviteUserGroup';
import { ReactComponent as EmptyGroupIcon } from '../../../assets/images/emptyGroupIcon.svg';
import { getTeamManagementHomePath } from '../../../config/featureFlags';

function AcceptGroupInvite() {
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.loginToken);
  const { token, id } = useParams();

  const InviteGroupHandler = async () => {
    const updateUser = dispatch(
      InviteUserGroupApi({
        token,
        id,
      }),
    );
    updateUser
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data.payload.status === 200) {
          toast.success('User Updated successfully.');
        } else if (data?.payload?.status === 404) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };
  useEffect(() => {
    InviteGroupHandler();
  }, [authToken]);

  return (
    <div>
      <div className="NoSuspendedAgent-main-Conatiner">
        <EmptyGroupIcon />
        <p className="NoOngoingChat01">
          Click on Add Group Button to add the group
        </p>
        <Link
          to={getTeamManagementHomePath()}
          style={{ textDecoration: 'none', paddingLeft: '5px' }}
        >
          <button
            className="NoOngoing-Chat-Button"
            type="button"

          >
            Join Group
          </button>
        </Link>
      </div>
    </div>
  );
}

export default AcceptGroupInvite;
